import { Leaf } from "lucide-react";
import { SUSTAINABILITY, IMAGES } from "../data/site";
import { Reveal, SectionHeading } from "./Reveal";

export const Sustainability = () => (
  <section data-testid="sustainability-section" className="relative py-20 sm:py-28 bg-[#EAF5D6] overflow-hidden">
    <div className="absolute inset-0 opacity-[0.08]" aria-hidden="true">
      <img src={IMAGES.garden} alt="" className="w-full h-full object-cover" loading="lazy" />
    </div>
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <SectionHeading index="03" eyebrow="Sustainability" title="Carbon-Conscious Living" dark />
          <Reveal delay={0.15}>
            <p className="mt-6 text-[#4D7C0F] text-base sm:text-lg max-w-2xl leading-relaxed">
              An IGBC Precertified Platinum Rated green building — every system at Vinayak 21 Acres is chosen to tread
              more lightly, from the water in your tap to the paint on your walls.
            </p>
          </Reveal>
        </div>
        <Reveal delay={0.2} className="lg:col-span-5">
          <div className="img-frame rounded-sm overflow-hidden bg-white">
            <img src={IMAGES.certificate} alt="IGBC Precertified Platinum certificate for Vinayak 21 Acres, Registration No. GH250539" className="w-full h-auto" loading="lazy" />
          </div>
          <p className="font-mono-spec text-[10px] tracking-[0.2em] uppercase text-[#84CC16] mt-3 text-center">IGBC Reg. No. GH250539 · October 2025</p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mt-12">
        {SUSTAINABILITY.map((item, i) => (
          <Reveal key={item} delay={0.05 * i}>
            <div
              data-testid={`sustainability-item-${i}`}
              className="border border-[#84CC16]/30 rounded-xl p-5 h-full bg-[#FFFFFF] backdrop-blur-sm hover:border-[#84CC16]/50 hover:bg-[#F4FAE8] transition-all duration-500"
            >
              <Leaf size={16} className="text-[#84CC16] mb-3" strokeWidth={1.6} />
              <p className="text-[#3F6212] text-sm leading-relaxed">{item}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
